// External
import React, { Component } from 'react'
import 'moment/locale/da'
import 'react-datepicker/dist/react-datepicker.css'

// Custom components
import Container from './components/ContainerComponent'
import Booking from './Booking'
import Locations from './components/LocationComponent'

class App extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedLocation: { location_id: null },
            step: 1,
            selectedRoom: {},
            startDate: undefined,
            termsAccepted: false,
            booking: {},
            order: {
                customer: {},
                order: {},
                card: {},
                startDate: undefined,
                confirmed: false
            }
        }
    }

    onSelectTab = step => {
        if (this.isTabAvailable(step)) {
            this.setState({ step })
        }
    }

    onSelectLocation = selectedLocation => this.setState({ selectedLocation })

    render() {
        const { selectedLocation } = this.state

        return (
            <Container>
                {selectedLocation.location_id !== null ? (
                    <Booking location_id={selectedLocation.location_id} config={selectedLocation.config || { terms_url: "/info/handelsbetingelser"}} /> 
                ) : (
                <React.Fragment>
                    {this.renderLocations()}
                </React.Fragment>
                )}
            </Container>
        )
    }


    renderLocations() {
        return <Locations location={this.state.selectedLocation} onSelectLocation={this.onSelectLocation} />
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js